import Icon from 'veui/components/Icon'

Icon.register({
  'bill-tearing': {
    paths: [
      {
        d: 'M640 64H160a96.11 96.11 0 00-96 96v544c-.38 24 29 43 52 25l60-48 60 48a32 32 0 0040 0l60-48 60 48a32 32 0 0040 0l60-48 60 48c17.27 14.81 51.34 5.41 52-25V256h96a32 32 0 0032-32v-64a96.11 96.11 0 00-96-96zM476 615l-60 48-60-48a32 32 0 00-40 0l-60 48-60-48a32 32 0 00-40 0l-28 22.41V160a32 32 0 0132-32h389.49a95.56 95.56 0 00-5.49 32v477.42L516 615a32 32 0 00-40 0zm196-423h-64v-32a32 32 0 0164 0zm-192 64a32 32 0 01-32 32H224a32 32 0 010-64h224a32 32 0 0132 32zm-96 128a32 32 0 01-32 32H224a32 32 0 010-64h128a32 32 0 0132 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
